import { render, staticRenderFns } from "./BaseFAQA.vue?vue&type=template&id=61796284&scoped=true&"
import script from "./BaseFAQA.vue?vue&type=script&lang=js&"
export * from "./BaseFAQA.vue?vue&type=script&lang=js&"
import style0 from "./BaseFAQA.vue?vue&type=style&index=0&id=61796284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61796284",
  null
  
)

export default component.exports